import { useEffect, useRef } from "react";

function useAutoLogout(logoutFunc) {
	const timerRef = useRef(null);

	const resetTimer = () => {
		let timeout = 60 * 60 * 1000; // 1 hour
		clearTimeout(timerRef.current);
		timerRef.current = setTimeout(() => {
			logoutFunc();
		}, timeout);
	};

	useEffect(() => {
		if (
			!/login|signup|otp|home|enugutccverification|unifiedpayment|flutterwave|remita|etranzact|moniepoint|reset-password|tax-type|tax-system|tax-collection|tax-legislation|about-us|frequently-asked-questions/i.test(
				window.location.pathname
			)
		) {
			const events = [
				"mousemove",
				"keydown",
				"click",
				"scroll",
				"touchstart"
			];

			events.forEach((event) =>
				window.addEventListener(event, resetTimer)
			);

			resetTimer();

			return () => {
				clearTimeout(timerRef.current);
				events.forEach((event) =>
					window.removeEventListener(event, resetTimer)
				);
			};
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}

export default useAutoLogout;
